<incubation-banner></incubation-banner>
<div class="ez-section-card">
    <incubation-intro></incubation-intro>
    <incubation-support></incubation-support>
    <incubation-benefits></incubation-benefits>
    <incubation-industries></incubation-industries>
    <sales></sales>
</div>